import React, { useEffect, useState } from 'react';

export function FadeInImage({
  src,
  alt,
  className = '',
  loading = 'lazy',
  style = {},
  fallbackSrc = '/img/noPhoto.webp',
  onLoad,
  onError,
  ...rest
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
    setHasError(false);
  }, [src]);

  const handleLoad = (event) => {
    setIsLoaded(true);
    if (onLoad) {
      onLoad(event);
    }
  };

  const handleError = (event) => {
    setHasError(true);
    setIsLoaded(true);
    if (onError) {
      onError(event);
    }
  };

  const resolvedSrc = hasError || !src ? fallbackSrc : src;

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      className={className}
      loading={loading}
      onLoad={handleLoad}
      onError={handleError}
      style={{
        opacity: isLoaded ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out, transform 0.3s ease',
        ...style,
      }}
      {...rest}
    />
  );
}
